// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon_edit_gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__dateStyle___Rwrxe {
  padding: 0;
}

.styles__section___DSVaR {
}

.styles__sectionNoMargin___ngo9W {
}

.styles__flexRow___bC24o {
}

.styles__dateInformation___HLG49 {
  height: 72px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
}

.styles__row___vfB0m {
  margin-bottom: 10px;
}

.styles__row___vfB0m:last-child {
    margin-bottom: 0;
  }

.styles__label___AqWqS {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 11px;
  margin-bottom: 3px;
}

.styles__error___wJ2fy {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__dateStyleActive___cHzyV {
}

.styles__dateStyleActive___cHzyV .styles__dateTitle___h6Hj0,
  .styles__dateStyleActive___cHzyV .styles__statusText___Smmh5 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    padding: 10px;
    padding-right: 30px;
  }

.styles__dateStyleActive___cHzyV .styles__dateTitle___h6Hj0::before, .styles__dateStyleActive___cHzyV .styles__statusText___Smmh5::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
    }

.styles__dateStyleClosed___ZOo4g {
}

.styles__dateStyleClosed___ZOo4g .styles__dateTitle___h6Hj0,
  .styles__dateStyleClosed___ZOo4g .styles__statusText___Smmh5 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
    padding: 10px;
    padding-right: 30px;
  }

.styles__dateStyleClosed___ZOo4g .styles__dateTitle___h6Hj0::before, .styles__dateStyleClosed___ZOo4g .styles__statusText___Smmh5::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
    }

.styles__dateStylePending___Qtj58 {
}

.styles__dateStylePending___Qtj58 .styles__dateTitle___h6Hj0,
  .styles__dateStylePending___Qtj58 .styles__statusText___Smmh5 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
    padding: 10px;
    padding-right: 30px;
  }

.styles__dateStylePending___Qtj58 .styles__dateTitle___h6Hj0::before, .styles__dateStylePending___Qtj58 .styles__statusText___Smmh5::before {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
    }

.styles__accountInfo___VKUIX {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 72px;
}

.styles__titleWithIcon___Afvs0 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.styles__refEdit___V018g {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 18px;
}

.styles__refEditSmall___GocZv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 13px;
  height: 13px;
  width: 13px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 16px;
  cursor: pointer;
}

.styles__dateTitle___h6Hj0 {
  height: 72px;
  font-weight: 500;
  justify-content: flex-end;
}

.styles__dateTitle___h6Hj0::before {
    content: '';
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    width: 10px;
  }

.styles__statusText___Smmh5 {
  height: 72px;
  font-weight: 500;
  justify-content: flex-end;
}

.styles__statusText___Smmh5::before {
    content: '';
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    width: 10px;
  }

.styles__lastUpdated___aH2II div.styles__row___vfB0m {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
    font-size: 12px;
    font-weight: light;
    margin-top: 4px;
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

.styles__lastUpdated___aH2II div.styles__row___vfB0m div.styles__label___AqWqS {
      margin-right: 5px;
      font-size: 12px;
    }

.styles__dateInfoPending___v2daN {
}

.styles__dateInfoPending___v2daN::before {
    display: flex;
    align-self: center;
    margin-left: -20px;
    position: absolute;
    content: '';
    width: 4px;
    height: 72px;
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  }

.styles__dateInfoOpen___DMoWo {
}

.styles__dateInfoOpen___DMoWo::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__dateInfoActive___NbL4C {
}

.styles__dateInfoActive___NbL4C::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__dateInfoClosed___tePdN {
}

.styles__dateInfoClosed___tePdN::before {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__singleLine___jUV_k {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 0 20px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
  background-color: white;
}

.styles__singleLine___jUV_k div.styles__label___AqWqS {
    font-size: 14px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    opacity: 0.9;
  }

.styles__separator___C1xC9 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.styles__rowError___RXGaB {
}

.styles__rowError___RXGaB .styles__value___VB84r,
  .styles__rowError___RXGaB .styles__label___AqWqS {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__rowError___RXGaB .styles__error___wJ2fy {
    font-weight: bold;
  }

.styles__valueMono___nSGgo {
  font-family: MaisonMono, monospace;
}

.styles__valueBlank___WpXB0 {
  color: #eee;
}

.styles__valueBold___xclYs {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/AccountInfoSection/styles.css"],"names":[],"mappings":"AAIA;EACE,UAAU;AACZ;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qEAAyC;AAC3C;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,oDAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mDAAY;AACd;;AAEA;AAaA;;AAVE;;IAEE,mDAAc;IACd,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,wDAAmB;IACrB;;AAIJ;AAaA;;AAVE;;IAEE,mDAAY;IACZ,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,wDAAiB;IACnB;;AAIJ;AAaA;;AAVE;;IAEE,mDAAmB;IACnB,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,yDAAoB;IACtB;;AAIJ;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EAEE,yDAAsD;EACtD,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EAEE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAS3B;;AAPE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;AAGF;EAEE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAS3B;;AAPE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;AAIA;IACE,oDAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EAMvB;;AAJE;MACE,iBAAiB;MACjB,eAAe;IACjB;;AAIJ;AAaA;;AAVE;IACE,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yDAAoB;EACtB;;AAGF;AAMA;;AAHE;IACE,wDAAmB;EACrB;;AAGF;AAMA;;AAHE;IACE,wDAAmB;EACrB;;AAGF;AAMA;;AAHE;IACE,wDAAiB;EACnB;;AAGF;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,qEAAyC;EACzC,uBAAuB;AAOzB;;AALE;IACE,eAAe;IACf,oDAAW;IACX,YAAY;EACd;;AAGF;EACE,8DAAwB;AAC1B;;AAEA;AAWA;;AARE;;IAEE,mDAAY;EACd;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAEb;;AAEA;EACE,mDAAiB;EAEjB,iBAAiB;AACnB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayLight, gtCardHeaderBG, borderColor, borderColorLight, gtGray, gtRed, gtBlueDark, gtGreen, gtGreenLight, gtYellowDark, gtYellow, gtYellowLight, text, textLight from colors;\n\n.dateStyle {\n  padding: 0;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.flexRow {\n  composes: flexRow from helpers;\n}\n\n.dateInformation {\n  composes: sectionNoMargin;\n  height: 72px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid borderColorLight;\n}\n\n.row {\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 11px;\n  margin-bottom: 3px;\n}\n\n.error {\n  color: gtRed;\n}\n\n.dateStyleActive {\n  composes: dateStyle;\n\n  .dateTitle,\n  .statusText {\n    color: gtGreen;\n    padding: 10px;\n    padding-right: 30px;\n\n    &::before {\n      background: gtGreen;\n    }\n  }\n}\n\n.dateStyleClosed {\n  composes: dateStyle;\n\n  .dateTitle,\n  .statusText {\n    color: gtRed;\n    padding: 10px;\n    padding-right: 30px;\n\n    &::before {\n      background: gtRed;\n    }\n  }\n}\n\n.dateStylePending {\n  composes: dateStyle;\n\n  .dateTitle,\n  .statusText {\n    color: gtYellowDark;\n    padding: 10px;\n    padding-right: 30px;\n\n    &::before {\n      background: gtYellow;\n    }\n  }\n}\n\n.accountInfo {\n  composes: sectionTitle from helpers;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  height: 72px;\n}\n\n.titleWithIcon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.refEdit {\n  background-image: url('styles/img/icon_edit.png');\n  background-size: 18px;\n}\n\n.refEditSmall {\n  composes: refEdit;\n  background-image: url('styles/img/icon_edit_gray.png');\n  background-size: 13px;\n  height: 13px;\n  width: 13px;\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-position: center;\n  margin-left: 16px;\n  cursor: pointer;\n}\n\n.dateTitle {\n  composes: sectionTitle from helpers;\n  height: 72px;\n  font-weight: 500;\n  justify-content: flex-end;\n\n  &::before {\n    content: '';\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 10px;\n    width: 10px;\n  }\n}\n\n.statusText {\n  composes: sectionTitle from helpers;\n  height: 72px;\n  font-weight: 500;\n  justify-content: flex-end;\n\n  &::before {\n    content: '';\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 10px;\n    width: 10px;\n  }\n}\n\n.lastUpdated {\n  div.row {\n    color: textLight;\n    font-size: 12px;\n    font-weight: light;\n    margin-top: 4px;\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n\n    div.label {\n      margin-right: 5px;\n      font-size: 12px;\n    }\n  }\n}\n\n.dateInfoPending {\n  composes: dateInformation;\n\n  &::before {\n    display: flex;\n    align-self: center;\n    margin-left: -20px;\n    position: absolute;\n    content: '';\n    width: 4px;\n    height: 72px;\n    background: gtYellow;\n  }\n}\n\n.dateInfoOpen {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtGreen;\n  }\n}\n\n.dateInfoActive {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtGreen;\n  }\n}\n\n.dateInfoClosed {\n  composes: dateInfoPending;\n\n  &::before {\n    background: gtRed;\n  }\n}\n\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 0 20px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid borderColorLight;\n  background-color: white;\n\n  div.label {\n    font-size: 14px;\n    color: text;\n    opacity: 0.9;\n  }\n}\n\n.separator {\n  background-color: gtGray;\n}\n\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  color: #eee;\n  composes: value;\n}\n\n.valueBold {\n  color: gtBlueDark;\n  composes: value;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"dateStyle": `styles__dateStyle___Rwrxe`,
	"section": `styles__section___DSVaR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"flexRow": `styles__flexRow___bC24o ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"dateInformation": `styles__dateInformation___HLG49 styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"row": `styles__row___vfB0m`,
	"label": `styles__label___AqWqS`,
	"error": `styles__error___wJ2fy`,
	"dateStyleActive": `styles__dateStyleActive___cHzyV styles__dateStyle___Rwrxe`,
	"dateTitle": `styles__dateTitle___h6Hj0 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"statusText": `styles__statusText___Smmh5 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"dateStyleClosed": `styles__dateStyleClosed___ZOo4g styles__dateStyle___Rwrxe`,
	"dateStylePending": `styles__dateStylePending___Qtj58 styles__dateStyle___Rwrxe`,
	"accountInfo": `styles__accountInfo___VKUIX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"titleWithIcon": `styles__titleWithIcon___Afvs0`,
	"refEdit": `styles__refEdit___V018g`,
	"refEditSmall": `styles__refEditSmall___GocZv styles__refEdit___V018g`,
	"lastUpdated": `styles__lastUpdated___aH2II`,
	"dateInfoPending": `styles__dateInfoPending___v2daN styles__dateInformation___HLG49 styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoOpen": `styles__dateInfoOpen___DMoWo styles__dateInfoPending___v2daN styles__dateInformation___HLG49 styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoActive": `styles__dateInfoActive___NbL4C styles__dateInfoPending___v2daN styles__dateInformation___HLG49 styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"dateInfoClosed": `styles__dateInfoClosed___tePdN styles__dateInfoPending___v2daN styles__dateInformation___HLG49 styles__sectionNoMargin___ngo9W ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"singleLine": `styles__singleLine___jUV_k`,
	"separator": `styles__separator___C1xC9`,
	"rowError": `styles__rowError___RXGaB styles__row___vfB0m`,
	"value": `styles__value___VB84r`,
	"valueMono": `styles__valueMono___nSGgo styles__value___VB84r`,
	"valueBlank": `styles__valueBlank___WpXB0 styles__value___VB84r`,
	"valueBold": `styles__valueBold___xclYs styles__value___VB84r`
};
export default ___CSS_LOADER_EXPORT___;
